// extracted by mini-css-extract-plugin
export default {"closeButtonIcon":"CloseButtonIcon_closeButtonIcon__jmK4+"};